import React from "react"; 
import { Link } from "react-router-dom";    
import EditCustomerOrderForm from "../../../components/Dashboard/CustomerOrdersListContent/Edit";

const EditCustomerOrder = () => {
  return (
    <>
      {/* Breadcrumb */}
      {/* <div className="breadcrumb-card">
        <h5>Edit Customer Order</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/dashboard/ecommerce/">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>Edit Customer Order</li>
        </ul>
      </div> */}

      <EditCustomerOrderForm />
    </>
  );
};

export default EditCustomerOrder;
